import { toast } from "react-toastify";
import apiCall from "../api/Api";

const AuthService = {
  login: async (userData) => {
    try {
      return await apiCall("POST", "login", userData);
    } catch (error) {
      toast.error(error?.userMessage || error?.response?.data?.message || "Login failed");
      throw error;
    }
  },
  logout: async () => {
    try {
      await apiCall("POST", "logout");
    } catch {
      // Best effort — the server session may already be expired; the caller
      // clears local state either way.
    }
  },
};

export default AuthService;
